export const SHORT_CODE_LENGTH = 6

/**
 * Returns the sanitized short code from the provided input. Keeps only digits and
 * trims the value so that at most the last six digits remain.
 */
export function sanitizeShortCodeInput(raw: string): string {
  const digitsOnly = raw.replace(/\D/g, '')

  if (digitsOnly.length <= SHORT_CODE_LENGTH) {
    return digitsOnly
  }

  return digitsOnly.slice(-SHORT_CODE_LENGTH)
}

/**
 * Extracts a complete short code when six digits are present. Returns null when
 * the input does not yet include six digits.
 */
export function extractCompleteShortCode(raw: string): string | null {
  const digitsOnly = raw.replace(/\D/g, '')

  if (digitsOnly.length < SHORT_CODE_LENGTH) {
    return null
  }

  return digitsOnly.slice(-SHORT_CODE_LENGTH)
}
